<template>
    <div ref="modal" class="modal fade" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{ title }}</h5>
                    <button @click="$emit('close')" type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <slot></slot>
                </div>
                <div class="modal-footer">
                    <button @click="$emit('close')" data-dismiss="modal" type="button" class="btn btn-success">Закрити</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import $ from "jquery";

    export default {
        name: "EmptyModal",
        props: ["open", "title"],
        data() {
            return {
                visible: false
            }
        },
        watch: {
            open(val) {
                if (val) {
                    $(this.$refs.modal).modal("show");
                    this.$emit('show')
                } else {
                    $(this.$refs.modal).modal("hide");
                    this.$emit('hide')
                }
            },
        },
        mounted() {
            $(this.$refs.closeButton).click(function () {
                this.$emit('close')
            });
        }
    }
</script>

<style lang="less" scoped>

    @import "../../node_modules/noty/lib/noty.css";
    @import "../../node_modules/noty/lib/themes/metroui.css";

</style>